import { finishStaticBuilderSaveProgressBarAnimation } from 'Animation/AnimationActions';
import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import MessageHandler from 'message-handler';
import StaticBuilderEnum from './StaticBuilderConstants';

const uuidV4 = require('uuid/v4');

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);
const formSwiftClient = new FormSwiftAPIClient(window.FORMSWIFT_URL || '');

export const setStaticBuilderNavStep = step => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_NAV_STEP_SET,
      step,
    });
  }
);

export const setStaticBuilderStepHistory = stepHistory => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_SET,
      stepHistory,
    });
  }
);

export const setStaticBuilderMenuButton = isOpen => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_MENU_BUTTON_SET,
      isOpen,
    });
  }
);

export const addStaticBuilderStepToHistory = step => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_ADD,
      step,
    });
  }
);

export const removeStaticBuilderStepFromHistory = idx => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_STEP_HISTORY_REMOVE,
      index: idx,
    });
  }
);

export const addStaticBuilderOnSectionLoadAction = onSectionLoadAction => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_LOAD_ACTION_ADD,
      onSectionLoadAction,
    });
  }
);

export const setStaticBuilderSectionKeys = sectionKeys => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_KEYS_SET,
      sectionKeys,
    });
  }
);

export const updateStaticBuilderPreview = version => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_UPDATE_PREVIEW,
      version,
    });
  }
);

export const getStaticBuilderSectionKeys = () => (
  (dispatch, getState) => {
    const staticBuilderReducer = getState().StaticBuilderReducer;
    return staticBuilderReducer.sectionKeys;
  }
);

export const setStaticBuilderFieldOutline = (documentType, fieldOutline, onStep = 0, forceDownload = false) => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_FIELD_OUTLINE_DATA_GET_SUCCESS,
      fieldOutline,
      step: onStep,
      documentType,
      forceDownload,
    });
  }
);

export const getSessionContent = (sessionId, sessionHash, forceDownload = false) => (
  async (dispatch) => {
    const userid = parseInt(window.COOKIE.get('userid'), 10);

    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SESSION_CONTENT_GET_REQUEST,
      userid,
      sessionId,
      sessionHash,
    });

    try {
      const payload = {
        session_hash: sessionHash,
        // ie11 caches fetch requests, in order to ensure we fetch latest field_outline
        // (and prevent blowing away data), add uuid to make every request unique
        version: uuidV4(),
      };

      if (forceDownload) {
        payload.force_download = forceDownload;
        payload.cloudflare_token = window.COOKIE.get('cloudflare_token');
      }

      if (userid) {
        payload.user_id = userid;
      }
      if (window.COOKIE.get('userToken')) {
        payload.user_token = window.COOKIE.get('userToken');
      }

      const response = await formSwiftAPIClient.request('GET', `/session/content/${sessionId}`, payload);
      const responseData = response.data;
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SESSION_CONTENT_GET_SUCCESS,
        data: responseData,
      });
    } catch (e) {
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SESSION_CONTENT_GET_FAILURE,
        error: e.message,
      });
    }
  }
);

export const loadStaticBuilderSectionConditionals = (
  documentType,
  sectionKey,
  sessionId,
  sessionHash,
) => (
  async (dispatch, getState) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONDITIONALS_GET_REQUEST,
      documentType,
      sectionKey,
      sessionId,
      sessionHash,
    });

    try {
      const state = getState();
      const {
        forceDownload,
      } = state.StaticBuilderReducer;

      const payload = {
        documentType,
        section: sectionKey,
        key: sessionId,
        hash: sessionHash,
        // ie11 caches fetch requests, in order to ensure we fetch latest field_outline
        // (and prevent blowing away data), add uuid to make every request unique
        version: uuidV4(),
      };

      if (window.COOKIE.get('userid') && window.COOKIE.get('userToken')) {
        payload.user_id = parseInt(window.COOKIE.get('userid'), 10);
        payload.user_token = window.COOKIE.get('userToken');
      }

      if (forceDownload) {
        payload.force_download = forceDownload;
        payload.cloudflare_token = window.COOKIE.get('cloudflare_token');
      }

      const rawResponse = await formSwiftClient.request(
        'GET',
        '/_api/static-editableSectionContent.php',
        payload,
        true,
      );

      const rawText = await rawResponse.text();
      if (!rawResponse.ok) {
        throw new Error(rawText.trim());
      }

      const rawTextTrimmed = rawText.trim();
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONDITIONALS_GET_SUCCESS,
        data: {
          sectionKey,
          conditionals: rawTextTrimmed,
        },
      });

      return {
        data: {
          status: 'success',
          sectionKey,
          conditionals: rawTextTrimmed,
        },
      };
    } catch (e) {
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONDITIONALS_GET_FAILURE,
        error: e.message,
      });

      return {
        data: {
          status: 'error',
          message: e.message,
        },
      };
    }
  }
);

export const loadStaticBuilderSection = sectionStep => (
  async (dispatch, getState) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_LOAD_REQUEST,
    });
    const state = getState();
    const {
      documentType,
      sectionKeys,
      sessionId,
      sessionHash,
      stepHistory,
    } = state.StaticBuilderReducer;
    const sectionKey = sectionKeys[sectionStep];

    dispatch(setStaticBuilderNavStep(sectionStep));

    const result = await dispatch(loadStaticBuilderSectionConditionals(
      documentType,
      sectionKey,
      sessionId,
      sessionHash,
    ));

    if (result.data.status !== 'success') {
      let errorMessage;
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SECTION_LOAD_ERROR,
        error: result.data.message,
      });

      switch (result.data.message) {
        case 'signin-required':
          errorMessage = MessageHandler.getErrorMessage(result.data.message);
          // Remove hash that keeps track of builder step before setting as redirectURL.
          window.location.hash = '';
          window.location.assign(`${window.SessionManager.baseUrl}sign-in?error=${encodeURI(errorMessage)}&redirectURL=${window.location}`);
          break;
        case 'invalid-permissions':
          errorMessage = MessageHandler.getErrorMessage(result.data.message);
          window.location.assign(`${window.SessionManager.baseUrl}my-documents?error=${encodeURI(errorMessage)}`);
          break;
        default:
          // log unkown errors
          FormSwiftAPIClient.logException(new Error(result.data.message));
          break;
      }
      return;
    }

    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_LOAD_SUCCESS,
    });


    dispatch(updateStaticBuilderPreview(Math.random()));

    if (window.User.isLoggedIn) {
      // Need to save lastSeenSection in order to load it up on next visit
      localStorage.setItem(
        `staticSection-${sessionId}`,
        sectionStep,
      );
      localStorage.setItem(
        `staticViewedScreens-${sessionId}`,
        JSON.stringify(stepHistory),
      );
    }

    dispatch(finishStaticBuilderSaveProgressBarAnimation());
  }
);


export const loadNextStaticBuilderSection = skipSection => (
  (dispatch, getState) => {
    const state = getState();
    const {
      sectionKeys,
      step: onStep,
    } = state.StaticBuilderReducer;

    let offset = 1;
    if ((window.User.isLoggedIn && !window.secondPresence) || window.showRequestSignature) {
      offset = 0;
    }

    if (onStep + offset >= sectionKeys.length) {
      return false;
    }
    if (!skipSection) {
      dispatch(addStaticBuilderStepToHistory(onStep));
    }

    dispatch(loadStaticBuilderSection(onStep + 1));

    return true;
  }
);

export const loadPreviousStaticBuilderSection = () => (
  (dispatch, getState) => {
    const state = getState();
    const {
      stepHistory,
      step: onStep,
    } = state.StaticBuilderReducer;

    if (stepHistory.length) {
      const previousStep = stepHistory[stepHistory.length - 1];
      dispatch(removeStaticBuilderStepFromHistory(stepHistory.length - 1));
      dispatch(loadStaticBuilderSection(previousStep));
      return true;
    }

    if (onStep - 1 < 0) {
      return false;
    }

    dispatch(loadStaticBuilderSection(onStep - 1));
    return true;
  }
);


export const saveStaticBuilderSectionContent = (
  sectionContent,
  sectionStep,
  sectionTitle,
  sessionId,
  sessionHash,
  nextStepEnabled,
  successAction,
) => (
  async (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONTENT_SAVE_REQUEST,
      sessionId,
      sessionHash,
    });
    try {
      const payload = {
        session_hash: sessionHash,
        section_index: sectionStep,
        user_id: window.COOKIE.get('userid'),
        user_token: window.COOKIE.get('userToken'),
        section_content: {
          // serialized formdata
          ...sectionContent,
        },
        section_data: {
          title: sectionTitle,
        },
        // ie11 caches fetch requests, in order to ensure we fetch latest field_outline
        // (and prevent blowing away data), add uuid to make every request unique
        version: uuidV4(),
      };

      const response = await formSwiftAPIClient.request(
        'POST',
        `/session/${sessionId}/section/update-or-add`,
        payload,
      );

      const { data } = response;
      const { section_content: sectionContents } = data;


      const sectionContentValues = {};
      sectionContents.forEach((sc) => {
        sectionContentValues[sc.key] = sc.text;
      });

      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONTENT_SAVE_SUCCESS,
        data: sectionContentValues,
      });

      if (nextStepEnabled && !window.User.isLoggedIn) {
        window.onbeforeunload = (event) => {
          // eslint-disable-next-line no-param-reassign
          event.returnValue = 'Changes you made may not be saved.';
        };
      } else {
        window.onbeforeunload = () => null;
      }

      if (successAction) {
        successAction();
      }

      if (nextStepEnabled) {
        const moreSteps = dispatch(loadNextStaticBuilderSection());
        if (!moreSteps) {
          window.SessionManager.proceedToAccountCreation();
        }
      }
    } catch (e) {
      dispatch({
        type: StaticBuilderEnum.STATIC_BUILDER_SECTION_CONTENT_SAVE_FAILURE,
        error: e.message,
      });
    }
  }
);

export const openCreateAccountModal = () => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_CREATE_ACCOUNT_MODAL_OPEN,
    });
  }
);

export const closeCreateAccountModal = () => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_CREATE_ACCOUNT_MODAL_CLOSE,
    });
  }
);

export const setFormSwiftLogoHasBeenClicked = () => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_FORMSWIFT_LOGO_HAS_BEEN_CLICKED_SET,
    });
  }
);

export const setStaticBuilderBackButton = isClicked => (
  (dispatch) => {
    dispatch({
      type: StaticBuilderEnum.STATIC_BUILDER_BACK_BUTTON_SET,
      isClicked,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderActions.jsx